export default __webpack_public_path__ + "static/media/pendant_of_shielding.88db0961.jpg";